<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">                      
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>       
                                  <e-column field='bill_id' headerText='生產單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                  <e-column field='bill_date'  format="yyyy-MM-dd" type="date" headerText='生產日期' width='180'></e-column>          
                                  <e-column field='bill_state_name' headerText='單況' width='120'></e-column>          
                                  <e-column field='source_bill_id' headerText='來源單號' width='180'></e-column>   
                                  <e-column field='production_unit_id' headerText='生產單位' width='140'></e-column>       
                                  <e-column field='schedule_bill_id' headerText='排程序號' width='140'></e-column>  
                                  <e-column field='style_id' headerText='款式編號' width='140'></e-column>  
                                  <e-column field='std_pages' headerText='每卷張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='produce_pages' headerText='生產張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                  <e-column field='start_label_no' headerText='標籤起始序號' width='180'></e-column>  
                                  <e-column field='end_label_no' headerText='標籤結束序號' width='180'></e-column>  
                                  <e-column field='memo' headerText='備註' width='260'></e-column>                             
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增標籤生產單" : "修改標籤生產單"' :buttons='e_buttons' 
                        width='50%'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                          
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">生產單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_bill_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>                              
                                </div>                                
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">生產日期</span>
                                  <ejs-datepicker id="datepicker" v-model="e_bill_date" :enabled="e_bill_state_id == 0" format="yyyy-MM-dd"></ejs-datepicker>                                
                                </div>
                                <div class="form-group col-md-4">
                                  <span class="about-title">來源單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_source_bill_id" :enabled="e_bill_state_id == 0" aria-required="true"></ejs-textbox>    
                                </div>  
                                   <div class="form-group col-md-12">
                                  <span class="about-title-verify">標籤款式</span>
                                  <ejs-dropdownlist id='enterprise' cssClass="custom-dropdown" :enabled="e_bill_state_id == 0" :dataSource='style_datas' :select="onLBStyleSelect" :allowFiltering='true' :fields='fields' v-model="e_style_id" ></ejs-dropdownlist>
                                </div>   
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >生產卷數</span>
                                  <ejs-numerictextbox id="numeric" format="### 卷" v-model="e_volumes" :enabled="e_bill_state_id == 0"  @change="updateLiter($event, index)" :min="0"></ejs-numerictextbox>
                                </div> 
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >每卷張數</span>                      
                                  <ejs-numerictextbox id="numeric" format="### 張"  v-model="e_std_pages" :enabled="false" :min="0"></ejs-numerictextbox>                           
                                </div>   
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >生產張數</span>                      
                                  <ejs-numerictextbox id="numeric" format="### 張"  v-model="e_produce_pages" :enabled="false" :min="0"></ejs-numerictextbox>                           
                                </div>   

                                <div class="form-group col-md-4">
                                  <span class="about-title">標籤起始序號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_start_label_no" :enabled="false"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-4">
                                  <span class="about-title">標籤結束序號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_end_label_no" :enabled="false" ></ejs-textbox>    
                                </div>                               
                                <div v-if="e_bill_state_id != '0' && e_bill_state_id != '1'" class="form-group col-md-4"> 
                                  <span class="about-title-verify">單況</span>
                                  <ejs-dropdownlist id='sales' cssClass="custom-dropdown"  :dataSource='production_state_datas' :fields='fields' :enabled="false" v-model="e_bill_state_id" ></ejs-dropdownlist>
                                </div>                              
                            
                                <div v-if="e_bill_state_id == '0' || e_bill_state_id == '1'" class="form-group col-md-3"> 
                                <span class="about-title-verify">單況</span>
                                  <ejs-dropdownlist id='sales' cssClass="custom-dropdown"  :dataSource='production_state_datas' :fields='fields' :enabled="false" v-model="e_bill_state_id" ></ejs-dropdownlist>
                                </div> 
                                <div class="form-group col-md-1" v-if="e_bill_state_id == '0' || e_bill_state_id == '1'" style='top: 12px;' >  
                                  <ejs-button
                                    iconCss="e-btn-sb-icons e-add-icon" v-on:click.native='onChange'
                                    cssClass="e-small e-round" aria-label="button"                                
                                  ><img width="30" src="img/avatars/change-circle-svgrepo-com.svg"></ejs-button>
                                </div> 
                                
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">生產單位</span>                               
                                  <ejs-dropdownlist id='unit' cssClass="custom-dropdown" :enabled="e_bill_state_id == 0" :dataSource='productionunit_datas' :fields='fields' v-model="e_production_unit_id" ></ejs-dropdownlist>
                                </div>  
                                
                                <div class="form-group col-md-4">
                                  <span class="about-title">入庫日期</span>          
                                  <ejs-datepicker id="datepicker" v-model="e_pre_in_stock_date" :enabled="e_bill_state_id == 0" format="yyyy-MM-dd" :showClearButton="true"></ejs-datepicker>                                
                                </div>                                 
                                <div class="form-group col-md-4">
                                  <span class="about-title">排程單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_schedule_bill_id" :enabled="false" ></ejs-textbox>    
                                </div>
                                <div class="form-group col-md-12">
                                  <span class="about-title">備註</span>
                                  <ejs-textbox floatLabelType="Always" :rows="1" :multiline="true" v-model="e_memo"  aria-required="true"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-12">                      
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='ref_contact_data' :dataSource='contact_datas' height='150' :allowExcelExport='true' :allowPaging='false' :allowSorting='false' :allowFiltering='false' :allowReordering='false'
                                      :toolbar='toolbarContact' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                      :beforeRender="beforeRender" :toolbarClick="toolbarContactClick"
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" >
                                      <e-columns>                   
                                        <e-column field='row_id' headerText='序號' aria-required="true" width='80'></e-column>                                   
                                        <e-column field='volumes_no' headerText='標籤卷編號' width='160' ></e-column>
                                        <e-column field='start_label_no' headerText='起始序號' width='160' :allowEditing='false'></e-column>      
                                        <e-column field='end_label_no' headerText='結束序號' width='160'  :allowEditing='false' ></e-column>                             
                                        <e-column field='pages' headerText='張數' width='120' format="N0" :allowEditing='false' :edit="stockParams" textAlign="Right" editType='numericedit' ></e-column>                    
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import { Query } from '@syncfusion/ej2-data';
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import { GridComponent, ColumnDirective, ColumnsDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';
import { ButtonComponent } from "@syncfusion/ej2-vue-buttons";

setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
      'Print': '列印',
      'Search': '搜尋',
      'Add': '新增',
      'Edit' : '修改',
      'Delete' : '刪除',
      'Update' : '確認',
      'Cancel' : '取消'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;


export default {
  name: 'Department',
  components: {   
    'ejs-button': ButtonComponent,
    'ejs-toast': ToastComponent,
    'ejs-datepicker': DatePickerComponent,
    'ejs-numerictextbox': NumericTextBoxComponent,
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-dropdownlist': DropDownListComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectData: null,
      e_isAdd: null, 
      
      e_bill_date: null, e_bill_id: null, e_source_bill_id: null, e_volumes: null, e_style_id: null, e_std_pages: null,
      e_produce_pages: null, e_start_label_no: null, e_end_label_no: null, e_bill_state_id : null, 
      e_production_unit_id: null, e_pre_in_stock_date: null, e_schedule_bill_id: null, e_memo: null,


      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],

   
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSize: 15, pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      editContactSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, showAddNewRow: true, newRowPosition: 'Bottom' },
      toolbar: null,
      toolbarContact: [
        { text: '取號', tooltipText: '取號', prefixIcon: 'e-btn-icon e-shapes e-icons e-icon-left', id: 'Get' , disabled: !(this.e_bill_state_id == '0' || this.e_bill_state_id == '1') } 
      ],

      datas:  [], contact_datas: [], productionunit_datas:  [], production_state_datas:  [], style_datas: [],
      production_state_enable: true,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      fields: { value: 'value', text: 'text', disabled: 'state' },
      stockParams : { 
        params: { 
          change: this.calculateTotalCost,
          decimals: 0,
          format: 'N'
      } },

      yesNoParams : {
        params: {
          allowFiltering: true,
          dataSource: [{ value: true, text: '是' }, { value: false, text: '否' }],
          query: new Query(),
          fields: { value: 'value', text: 'text'},         
        },
      },
    
      isGiftTemplate: function () { return { 
          template: Vue.component("isGiftTemplate", {
          template:  `<div>{{name}}</div>`,             
          computed: {
              name: function() {
                  return this.data.is_gift ? "是" : "否";
              }
          }
      })}},
      isEstimateTemplate: function () { return { 
          template: Vue.component("isEstimateTemplate", {
          template:  `<div>{{name}}</div>`,              
          computed: {
              name: function() {
                  return this.data.is_estimate ? "是" : "否";
              }
          }
      })}},
      isCloseTemplate: function () { return { 
          template: Vue.component("isCloseTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.data.is_close ? "是" : "否";
              }
          }
      })}},
      dateTemplate: function () { return { 
          template: Vue.component("dateTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.pre_deliver_date.toISOString().split('T')[0]
              }
          }
      })}},
      
    };
  },
  methods: {    
    toolbarClick: function (args) {     
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除生產單號${this.e_selectData.bill_id}的資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {    
        this.e_isAdd = true;
        this.e_bill_id = "";
        this.e_bill_date  = new Date();      
        this.e_bill_state_id = "0";
        this.e_source_bill_id = "";
        this.e_style_id = null;
        this.e_volumes = 1;
        this.e_std_pages = "";
        this.e_produce_pages = "";
        this.e_start_label_no = "";
        this.e_end_label_no = "";
        this.e_bill_state_name = "";
        this.e_production_unit_id  = this.productionunit_datas[0].value;
        this.e_deliver_mehtod  = "";
        this.e_pre_in_stock_date  = "";
        this.contact_datas = [];
        this.getNumber();
        this.toolbarContact = [
          { text: '取號', tooltipText: '取號', prefixIcon: 'e-btn-icon e-shapes e-icons e-icon-left', id: 'Get' , disabled: this.e_bill_state_id != '0' }];
        this.$refs.modalDialog.show();    
      }
      if (args.item.id == 'Edit') {
        this.recordDoubleClick(); 
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'標籤訂購單.xlsx' });
      }  
      if (args.item.id == "PrintOnly") {     

        fetch(this.e_selectData.report_url, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        })
          .then(res => res.blob())
          .then(blob => {
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank"); // 用 Blob URL 開新頁
        });
      } 
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {       
      this.toolbar =  [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },  
        { text: '單筆列印', tooltipText: '單筆列印', prefixIcon: 'e-btn-icon e-print e-icons e-icon-left', id: 'PrintOnly' },     
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'];
    },
    updateLiter: function(event, index) { 
     
      this.e_produce_pages = this.e_std_pages * event.value;
      console.log(index);
    },

    checkZero : function (data){
      if(data.length == 1){
        data = "0" + data;
      }
      return data;
    },
    onChange:function() {
      this.e_bill_state_id =  this.e_bill_state_id  == "0" ? "1" : "0";       
    },
    toolbarContactClick: function() {    
      // var date = `${this.checkZero(this.e_bill_date.getFullYear() + "")}-${this.checkZero((this.e_bill_date.getMonth() + 1) + "")}-${this.checkZero(this.e_bill_date.getDate() + "")}`;
      var date = this.formatDate(this.e_bill_date);
      if (this.e_style_id == null) {
        this.$refs.toastRef.show( { title: '錯誤!', content: '請選擇標籤款式', cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' })
        return;
      }
      //if (args.item.id == 'Get') {      
        this.showLoading();
        this.axios({
            method: 'get',
            baseURL: Vue.prototype.GLOBAL.baseURL,
            url: `LBProduction/Sub/No?bill_date=${date}&style_id=${this.e_style_id}&volumes=${this.e_volumes}`,
            headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` }            
        })
        .then((response) => {       
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
          this.hideLoading();
          this.contact_datas = response.data.datas.sub;
          this.e_start_label_no = response.data.datas.start_label_no;
          this.e_end_label_no = response.data.datas.end_label_no;
        })
        .catch((error) => { this.showError(error, true) }
       
       )
      //}
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');     
      this.e_selectData = args.data;   
      this.getProductionSub(args.data.bill_id);
      this.checkHeader();
    },
    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBProduction',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id: this.e_selectData.bill_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');         
        this.hideLoading();
        this.getLBProductionMain();       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },   
    calculateTotalCost: function() {   
      const formEle = this.$refs.ref_contact_data.$el.ej2_instances['0'].element.querySelector('form')['ej2_instances'][0];
      formEle.getInputElement('pages').value = formEle.getInputElement('style_pages').value * formEle.getInputElement('volumes').value;
      formEle.getInputElement('no_deliver_volumes').value = formEle.getInputElement('volumes').value;      
    },      
    delCancelClick: function() {
       this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
        DialogObj.hide();
    },    
    editOkClick: function() {     
      if (this.e_style_id == "" || this.e_style_id == null) {
        this.$refs.toastRef.show( { title: '警告!', content: '請選擇標籤款式!' , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });  
        return
      }
      this.contact_datas.forEach(obj => {
        obj.bill_id = this.e_bill_id;
      })
      
      this.showLoading();
      this.axios({
          method: this.e_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBProduction',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            main: {
              bill_id : this.e_bill_id,
              bill_date : this.e_bill_date,
              style_id : this.e_style_id,
              source_bill_id : this.e_source_bill_id,
              produce_pages : this.e_produce_pages,
              std_pages : this.e_std_pages,
              volumes : this.e_volumes,
              start_label_no : this.e_start_label_no,
              end_label_no : this.e_end_label_no,
              production_unit_id : this.e_production_unit_id,
              schedule_bill_id : this.e_schedule_bill_id,
              pre_in_stock_date : this.e_pre_in_stock_date,
              bill_state : this.e_bill_state_id,
              memo : this.e_memo,
            }, sub : 
            this.contact_datas
          }
      })
      .then((response) => {      
        this.hideLoading(); 
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
        this.$refs.modalDialog.hide();           
        this.getLBProductionMain();   
      })
      .catch((error) => { this.showError(error, true) }
      ) 

    },  
    recordDoubleClick: function () {         
      this.e_isAdd = false;

      this.e_bill_id = this.e_selectData.bill_id; 
      this.e_bill_date = new Date(this.e_selectData.bill_date);
      this.e_source_bill_id = this.e_selectData.source_bill_id;
      this.e_style_id = this.e_selectData.style_id;
      this.e_volumes = this.e_selectData.volumes;
      this.e_std_pages = this.e_selectData.std_pages;
      this.e_produce_pages = this.e_selectData.produce_pages;
      this.e_start_label_no = this.e_selectData.start_label_no;
      this.e_bill_state_id = this.e_selectData.bill_state.toString();
      this.e_end_label_no = this.e_selectData.end_label_no;
      this.e_bill_state_name = this.e_selectData.bill_state_name;
      this.e_production_unit_id = this.e_selectData.production_unit_id;
      this.e_deliver_mehtod = this.e_selectData.deliver_mehtod;
      this.e_pre_in_stock_date = new Date(this.e_selectData.pre_in_stock_date);
      this.e_schedule_bill_id = this.e_selectData.schedule_bill_id;
      this.e_memo = this.e_selectData.memo; 
      this.toolbarContact = [
        { text: '取號', tooltipText: '取號', prefixIcon: 'e-btn-icon e-shapes e-icons e-icon-left', id: 'Get' , disabled: this.e_bill_state_id != '0' }];
    
      this.$refs.modalDialog.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    onLBStyleSelect: function(e) {
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBStyle/ID?id=${e.item.dataset.value}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }               
          this.e_std_pages = response.data.datas.std_pages;       
          this.e_produce_pages = this.e_std_pages * this.e_volumes;
      })
      .catch((error) => { this.showError(error, true) }
      )      
    },
    getLBProductionMain: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBProduction/Main',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.e_selectData = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getProductionSub: function (bill_id) {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBProduction/Sub?bill_id=${bill_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }      
          this.contact_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getProductionUnit: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBProduction/Unit/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }   
          this.productionunit_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getNumber: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/General/Number?type=production`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.e_bill_id = response.data.datas  
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getLBStyle: function () {        
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStyle/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.style_datas = response.data.datas;        
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getProductionState: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBProduction/State`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.production_state_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },  

    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getLBProductionMain();
    this.getProductionUnit();
    this.getProductionState();
    this.getLBStyle();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}

</style>
<style lang="scss" src="../../scss/base.scss"></style>
